import { createTheme, Theme } from "@mui/material";

export const theme: Theme = createTheme({
  direction: "ltr",
});
